module.exports = __webpack_public_path__ + "static/media/happyman.a630cf31.jpg";